import "core-js/modules/es.number.to-fixed.js";
import React from 'react';
import { Box, Typography, GRAY } from '@applyboard/ui-components';
import { CollapsibleCard } from "../Card";
import { Grade } from "./Grade";
export var MinimumMarks = function MinimumMarks(_ref) {
  var title = _ref.title,
    average = _ref.average,
    reading = _ref.reading,
    writing = _ref.writing,
    listening = _ref.listening,
    speaking = _ref.speaking,
    _ref$requiredMinimumM = _ref.requiredMinimumMark,
    requiredMinimumMark = _ref$requiredMinimumM === void 0 ? 0 : _ref$requiredMinimumM;
  if (!average) return null;
  var showReading = !!reading && reading > requiredMinimumMark;
  var showWriting = !!writing && writing > requiredMinimumMark;
  var showListening = !!listening && listening > requiredMinimumMark;
  var showSpeaking = !!speaking && speaking > requiredMinimumMark;
  var showToggle = showReading || showWriting || showListening || showSpeaking;
  return /*#__PURE__*/React.createElement(CollapsibleCard, {
    header: /*#__PURE__*/React.createElement(Typography, {
      variant: "section",
      style: {
        color: GRAY[5]
      }
    }, title),
    excerpt: /*#__PURE__*/React.createElement(Typography, {
      variant: "h2",
      style: {
        color: GRAY[5]
      }
    }, average.toFixed(1)),
    withSeparator: true,
    nameForEventTracking: "Minimum Language Test Scores - ".concat(title)
  }, showToggle && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    mt: 1,
    justifyContent: "space-between"
  }, showReading && /*#__PURE__*/React.createElement(Grade, {
    type: "Reading",
    grade: reading
  }), showWriting && /*#__PURE__*/React.createElement(Grade, {
    type: "Writing",
    grade: writing
  }), showListening && /*#__PURE__*/React.createElement(Grade, {
    type: "Listening",
    grade: listening
  }), showSpeaking && /*#__PURE__*/React.createElement(Grade, {
    type: "Speaking",
    grade: speaking
  })));
};